export enum WINDOW_LISTNER_EVENTS {
  ORIENTATION_CHANGE = 'orientationChange',
  MOUSEDOWN = 'mousedown',
  POPSTATE = 'popstate',
  CLICK = 'click'
}
